import React, { useState, useEffect } from 'react';
import { FaLinkedin, FaPlus, FaTrash } from 'react-icons/fa';

// Card Components
const Card = ({ className, children, ...props }) => (
  <div className={`rounded-lg border bg-white shadow-sm ${className}`} {...props}>
    {children}
  </div>
);

const CardHeader = ({ className, ...props }) => (
  <div className={`flex flex-col space-y-1.5 py-0 px-2 ${className}`} {...props} />
);

const CardContent = ({ className, ...props }) => (
  <div className={`p-2 pt-0 ${className}`} {...props} />
);

const Textarea = ({ className, ...props }) => (
  <textarea
    className={`flex min-h-[80px] sm:min-h-[120px] w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    {...props}
  />
);

// Input Component
const Input = ({ label, className, ...props }) => (
  <div className="mb-4">
    <label className="block text-gray-700 text-sm font-bold mb-2">
      {label}
    </label>
    <input
      className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${className}`}
      {...props}
    />
  </div>
);

const Addreference = () => {
  const [showForm, setShowForm] = useState(false);
  const [newRecommendation, setNewRecommendation] = useState({
    name: '',
    role: '',
    linkedinUrl: '',
    recommendation: '',
    date: new Date().toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '-'),
    isNew: true,
    createdAt: null
  });
  
  const [people, setPeople] = useState([
    {
      name: 'Aakash Kumar Yadav',
      role: 'President of GeeksforGeeks Student Chapter SRM RMP | Data/Business Analyst | SQL | Python | LeetCode Enthusiast',
      recommendation: 'I highly recommend Amisha Kumari for her exceptional dedication and leadership. She is not only a great developer but also possesses strong management and communication skills, ensuring that the team remains active and engaged. Her ability to take responsibility and lead with enthusiasm makes her truly deserving of a team lead position. Amisha consistently goes above and beyond, making her an invaluable asset to any team or project.',
      date: '2-02-2025',
      isNew: false,
      linkedinUrl: 'https://www.linkedin.com/in/aakash-k-yadav',
      createdAt: null
    },
    {
      name: 'Bhupalam Venkata Datta sai',
      role: 'Founder @99th floor |SDE(intern)at fiserv |winner of web3 hackathon by lumos labs🏅|won gen ai hackathon (mentors fav category)|web 3.0|web 3.0 enthusiast!',
      recommendation: 'Amisha Kumari is one of the most dynamic and adaptable individuals I have worked with. She learns incredibly fast, adapts effortlessly to new challenges, and thrives in competitive environments. Her ability to take ownership of tasks and drive projects forward makes her an outstanding leader. Whether it is managing a team or diving deep into technical complexities, she consistently delivers excellence with enthusiasm and determination. ',
      date: '2-02-2025',
      isNew: false,
      linkedinUrl: 'https://www.linkedin.com/in/bhupalam-venkata-datta-sai-9408371b5',
      createdAt: null
    },
    {
      name: 'Kunal Yadav',
      role: <>Lead Consultant at Infosys<br />Bengaluru, India</>,
      recommendation: 'I would like to take this opportunity Amisha Kumari, a standout BTech student specializing in Computer Science with a focus on AI & ML. Throughout her academic journey, she has consistently demonstrated exceptional academic prowess, maintaining an impeccable CGPA of 10. Her dedication to her studies is truly commendable.What sets Amisha apart is her remarkable ability to apply theoretical knowledge to practical problems. She has a natural talent for problem-solving, which she has showcased through her active participation in numerous tech hackathons',
      date: '17-02-2025',
      isNew: false,
      linkedinUrl: 'https://www.linkedin.com/in/kunal-yadav-54614211a',
      createdAt: null
    }
  ]);

  // Check and update delete availability for new recommendations
  useEffect(() => {
    const interval = setInterval(() => {
      setPeople(prevPeople => 
        prevPeople.map(person => {
          if (person.isNew && person.createdAt) {
            const now = new Date();
            const timeDiff = now - new Date(person.createdAt);
            const twoMinutesInMs = 2 * 60 * 1000;
            
            // If 2 minutes have passed, remove the isNew flag
            if (timeDiff > twoMinutesInMs) {
              return { ...person, isNew: false };
            }
          }
          return person;
        })
      );
    }, 10000); // Check every 10 seconds

    return () => clearInterval(interval);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewRecommendation(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Format role for display if it contains designation and location
    const designationParts = newRecommendation.role.split('|');
    const formattedRole = designationParts.length > 1 ? (
      <>{designationParts[0].trim()}<br />{designationParts[1].trim()}</>
    ) : newRecommendation.role;
    
    const newPerson = {
      ...newRecommendation,
      role: formattedRole,
      isNew: true,
      createdAt: new Date().toISOString() // Set creation timestamp
    };
    
    setPeople([...people, newPerson]);
    setShowForm(false);
    
    // Reset form
    setNewRecommendation({
      name: '',
      role: '',
      linkedinUrl: '',
      recommendation: '',
      date: new Date().toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\//g, '-'),
      isNew: true,
      createdAt: null
    });
  };

  const handleDelete = (index) => {
    const person = people[index];
    
    // Only allow deletion if the recommendation is new and within 2 minutes
    if (person.isNew && person.createdAt) {
      const now = new Date();
      const timeDiff = now - new Date(person.createdAt);
      const twoMinutesInMs = 2 * 60 * 1000;
      
      if (timeDiff <= twoMinutesInMs) {
        const updatedPeople = [...people];
        updatedPeople.splice(index, 1);
        setPeople(updatedPeople);
      }
    }
  };

  // Calculate if delete should be shown (new recommendation and within 2 minutes)
  const shouldShowDelete = (person) => {
    if (person.isNew && person.createdAt) {
      const now = new Date();
      const timeDiff = now - new Date(person.createdAt);
      const twoMinutesInMs = 2 * 60 * 1000;
      return timeDiff <= twoMinutesInMs;
    }
    return false;
  };

  const handleRecommendationChange = (index, value) => {
    const updatedPeople = [...people];
    updatedPeople[index].recommendation = value;
    setPeople(updatedPeople);
  };

  return (
    <>
      <div className="min-h-screen bg-[#50C878] px-4 py-8 sm:p-8">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-8 sm:mb-12 tracking-wider">
          RECOMMENDATIONS
        </h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 justify-items-center">
          {people.map((person, index) => (
            <Card 
              key={index} 
              className="hover:shadow-md border-black border-2 transition-shadow h-auto min-h-[200px] sm:min-h-[280px] w-full max-w-[500px] lg:max-w-[600px] p-2 overflow-hidden relative"
            >
              <CardHeader className="border-b border-gray-100">
                <div className="flex justify-between items-start w-full">
                  <div className="mr-2">
                    <h2 className="text-lg sm:text-xl font-bold text-gray-900 line-clamp-1">{person.name}</h2>
                    <div className="text-gray-500 text-sm sm:text-base line-clamp-2">{person.role}</div>
                  </div>
                  <div className="flex gap-3 mt-1 sm:mt-3 flex-shrink-0">
                    <a 
                      href={person.linkedinUrl} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-gray-400 hover:text-orange-600 transition-colors"
                      aria-label="LinkedIn Profile"
                    >
                      <FaLinkedin className="text-gray-500 w-[20px] h-[20px] sm:w-[30px] sm:h-[30px] transition duration-300 hover:text-orange-600" />
                    </a>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <Textarea 
                  value={person.recommendation}
                  onChange={(e) => handleRecommendationChange(index, e.target.value)}
                  placeholder="Add your recommendation here..."
                  className="resize-none text-sm sm:text-base"
                />
                <div className="flex justify-between items-center mt-1">
                  <div>
                    {shouldShowDelete(person) && (
                      <button 
                        onClick={() => handleDelete(index)} 
                        className="text-gray-400 hover:text-red-600 transition-colors"
                        aria-label="Delete recommendation"
                      >
                        <FaTrash className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                  <span className="text-gray-500 text-xs sm:text-sm">{person.date}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        {/* Add Recommendation Button */}
        <div className="flex justify-center mt-8 sm:mt-12">
          <button 
            onClick={() => setShowForm(!showForm)}
            className="bg-white text-black border-2 border-black rounded-full p-3 sm:p-4 hover:bg-gray-100 transition-colors shadow-md"
            aria-label="Add recommendation"
          >
            <FaPlus className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
        </div>
        
        {/* Add Recommendation Form */}
        {showForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4 py-6">
            <div className="bg-white p-4 sm:p-6 rounded-lg w-full max-w-md shadow-xl border-2 border-black overflow-y-auto max-h-[90vh]">
              <h2 className="text-xl sm:text-2xl font-bold mb-4">Add Recommendation</h2>
              <form onSubmit={handleSubmit}>
                <Input 
                  label="Full Name" 
                  type="text" 
                  name="name" 
                  value={newRecommendation.name}
                  onChange={handleInputChange}
                  placeholder="Enter full name" 
                  required 
                />
                
                <Input 
                  label="Designation/Bio" 
                  type="text" 
                  name="role" 
                  value={newRecommendation.role}
                  onChange={handleInputChange}
                  placeholder="Enter designation (use | to separate lines)" 
                  required 
                />
                
                <Input 
                  label="LinkedIn Profile URL" 
                  type="url" 
                  name="linkedinUrl" 
                  value={newRecommendation.linkedinUrl}
                  onChange={handleInputChange}
                  placeholder="https://linkedin.com/in/username" 
                />
                
                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Recommendation
                  </label>
                  <textarea
                    name="recommendation"
                    value={newRecommendation.recommendation}
                    onChange={handleInputChange}
                    placeholder="Write your recommendation here..."
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline h-24 sm:h-32"
                    required
                  ></textarea>
                </div>
                
                <Input 
                  label="Date" 
                  type="text" 
                  name="date" 
                  value={newRecommendation.date}
                  onChange={handleInputChange}
                  disabled 
                />
                
                <div className="flex justify-end space-x-4 mt-6">
                  <button 
                    type="button"
                    onClick={() => setShowForm(false)}
                    className="py-2 px-3 sm:px-4 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors text-sm sm:text-base"
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit"
                    className="py-2 px-3 sm:px-4 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors text-sm sm:text-base"
                  >
                    Publish
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Addreference;